<template>
  <div class="m-nav">
    <button class="m-nav__back" @click="prev">Back</button>
    <div class="m-nav__dots">
      <div class="m-nav__dot" :class="{'active': $store.state.indexUI == 1}"></div>
      <div class="m-nav__dot" :class="{'active': $store.state.indexUI == 2}"></div>
      <div class="m-nav__dot" :class="{'active': $store.state.indexUI == 3}"></div>
      <div class="m-nav__dot" :class="{'active': $store.state.indexUI == 4}"></div>
    </div>
    <button class="m-nav__next" @click="next">Next</button>
  </div>
</template>

<script>

export default {
  name: 'Nav',
  data () {
    return {
    }
  },
  methods: {
    prev () {
      this.$store.commit('PREV_PAGE')
    },
    next () {
      if (this.$store.state.pageValidation[this.$store.state.indexUI] == true ) {
        this.$store.commit('NEXT_PAGE')
      } else {
        this.$emit('validationError', this.$store.state.indexUI)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../scss/vars';
.m-nav {
  border-top: 1px solid $cGray;
  padding-top: 17.5px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
  @media (max-width: $sm) {
    position: relative;
    margin-top: 40px;
  }
  &__back {
    font-family: $fPrimary;
    font-size: 18px;
    font-weight: $fReg;
    line-height: 42px;
    border: none;
    background: transparent;
    color: $cGrayText;
    cursor: pointer;
  }
  &__next {
    width: 118px;
    height: 48px;
    font-family: $fPrimary;
    font-size: 18px;
    font-weight: $fMed;
    line-height: 42px;
    border: none;
    border-radius: 4px;
    background: $cTeal;
    color: #F2F2F2;
    cursor: pointer;
  }
  &__dots {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    width: 100px;
    @media (max-width: $sm) {
      display: none;
    }
  }
  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: $cTeal;
    opacity: 0.2;
    transition: all 0.2s ease-in;
    &.active {
      opacity: 1;
      transition: all 0.2s ease-in;
    }
  }
}
</style>
